"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Database = void 0;
var dexie_1 = __importDefault(require("dexie"));
var Database = (function (_super) {
    __extends(Database, _super);
    function Database() {
        var _this = _super.call(this, 'bf_sdk') || this;
        _this.version(1).stores({
            devicekeys: '++id, sessionUUID',
            issues: '++id, sessionUUID',
            logs: '++id, sessionUUID',
            sessions: 'uuid',
        });
        _this.devicekeys = _this.table('devicekeys');
        _this.issues = _this.table('issues');
        _this.logs = _this.table('logs');
        _this.sessions = _this.table('sessions');
        return _this;
    }
    return Database;
}(dexie_1.default));
exports.Database = Database;
